import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useResetPasswordTimeOut } from "./hook";

export const ResetPasswordTimeOutPage: React.FC = () => {
  const { handleResetPasswordTimeOut } = useResetPasswordTimeOut();

  return (
    <CardTemplate title="パスワード再設定の 有効期限が切れました">
      <StyledTextContainer>
        パスワード再設定ページの有効期限が切れました。メール送信画面から再度メールを送信してください。
      </StyledTextContainer>

      <Button
        text="メール送信画面へ"
        variant="filled"
        onClick={handleResetPasswordTimeOut}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;
